import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './sentry';   // 副作用导入:初始化错误监控(无 DSN 时为 no-op)
import './native';   // 副作用导入:Capacitor 原生桥(web 模式下 no-op)
import App from './ShoppingApp';
import ErrorBoundary from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
